let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("73Ybz")).then(() => parcelRequire('lQKQC'));